import React, { useContext, useEffect, useState } from 'react'
import '../window/style/window.css'
import cjt from '../../assets/icon/dright.png'
import returnTop from '../../assets/icon/returnTop.png'
import { Alert, Menu, Pagination, Spin } from 'antd'
import classNames from 'classnames'
import WeekHot from '../../assembly/weekHot/weekHot.jsx'
import AllRank from '../../assembly/allRanking/allRank'
import { useLocation, useNavigate } from 'react-router-dom'
import api from '../../uitil/api'
import { encode } from 'js-base64'
import { CountContext } from '../../App'

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  }
}
//选项卡导航数据
const items = [
  getItem('全部软件', '1201', null),
  getItem('安全', '1202', null, [getItem('系统防护', '120201')]),
  getItem('办公', '1203', null, [
    getItem('办公套件', '120301'),
    getItem('输入法', '120302'),
    getItem('文字编辑', '120303'),
    getItem('邮件管理', '120304'),
  ]),
  getItem('多媒体', '1204', null, [
    getItem('媒体播放', '120401'),
    getItem('媒体转换', '120402'),
    getItem('视频编辑', '120403'),
    getItem('图片浏览', '120404'),
    getItem('网络电台', '120405'),
    getItem('音乐播放', '120406'),
  ]),
  getItem('设计', '1205', null, [
    getItem('3D制作', '120501'),
    getItem('平面设计', '120502'),
    getItem('视频编辑', '120503'),
  ]),
  getItem('图形软件', '1206', null, [
    getItem('图片处理', '120601'),
    getItem('图片浏览', '120602'),
  ]),
  getItem('网络', '1207', null, [
    getItem('FTP工具', '120701'),
    getItem('WiFi管理', '120702'),
    getItem('聊天工具', '120703'),
    getItem('模拟器', '120704'),
    getItem('上传下载', '120705'),
    getItem('网络分享', '120706'),
  ]),
  getItem('系统', '1208', null, [
    getItem('开发编程', '120801'),
    getItem('系统辅助', '120802'),
    getItem('系统修复', '120803'),
    getItem('系统优化', '120804'),
  ]),
  getItem('应用软件', '1209', null, [
    getItem('剪贴拷贝', '120901'),
    getItem('设备管理', '120902'),
    getItem('手机管理', '120903'),
    getItem('文件管理', '120904'),
    getItem('压缩工具', '120905'),
  ]),
]
const rootSubmenuKeys = [
  '1201',
  '1202',
  '1203',
  '1204',
  '1205',
  '1206',
  '1207',
  '1208',
  '1209',
]
export default function Macsoftware() {
  //获取路由参数
  const { pathname } = useLocation()

  //选项卡导航
  const [openKeys, setOpenKeys] = useState([])
  //初始化调用一次
  useEffect(() => {
    window.scrollTo(0, 0)
    winWeeks('12')
    const a = pathname.slice(5, 9)
    const b = pathname.slice(10, 16)
    if (a && b) {
      setOpenKeys([b, a])
      macSecurity(a, b)
    } else {
      setOpenKeys(['1201'])
      macSecurity()
    }
  }, [pathname])
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1)
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys)
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
    }
  }
  //选项卡
  const [table, setTable] = useState(1)
  //内容数据
  const [recommends, setRecommends] = useState([])

  //获取context上下文总排行榜
  const value = useContext(CountContext)
  //本周热门
  const [winWeek, setWinWeek] = useState([])
  const winWeeks = async (weeksApi) => {
    await api.get(`hot/sumType/${weeksApi}`).then((data) => {
      setWinWeek(data)
    })
  }

  //请求接口
  const macSecurity = async (softType = '1201', subSoftType = '120101') => {
    await api
      .get(`query/sumType/12/softType/${softType}/subSoftType/${subSoftType}`)
      .then((data) => {
        setRecommends(data)
      })
  }

  //分页
  //页数
  const [current, setCurrent] = useState(1)
  // 用于存储每页的数据
  const [recommend, setRecommend] = useState([])
  //每页目数
  const [pageSize, setPageSize] = useState(20)

  const onChange = (page) => {
    setCurrent(page)
    window.scrollTo(0, 0)
  }

  // 根据当前页码和每页条目数获取当前页的数据
  const getCurrentPageData = (items) => {
    const startIndex = (current - 1) * pageSize // 假设每页条目数为 20，可以根据需要修改
    const endIndex = startIndex + pageSize
    const page = items.slice(startIndex, endIndex)
    return setRecommend(page)
  }
  useEffect(() => {
    getCurrentPageData(recommends)
  }, [current, recommends, pageSize, table])

  const history = useNavigate()
  //返回顶部
  const [scrollPosition, setScrollPosition] = useState(0)
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY)
    }
    window.addEventListener('scroll', handleScroll)

    const myElement = document.getElementsByClassName('retuntop')[0]
    if (scrollPosition > 0) {
      console.log(111)
      myElement.style.display = 'block'
      myElement.classList.remove('move-down')
      myElement.classList.add('move-up')
    } else {
      myElement.classList.remove('move-up')
      myElement.classList.add('move-down')
    }
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [scrollPosition])

  return (
    <>
      <div className="win_all">
        <div className="win_left">
          <p>分类</p>
          <Menu
            mode="inline"
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            selectedKeys={openKeys}
            defaultSelectedKeys={openKeys}
            style={{
              width: 150,
              backgroundColor: 'white',
            }}
            items={items}
            onClick={(e) => {
              history('/')
              setCurrent(1)
              setTable(1)
              setRecommends([])
              if (e.key === '1201') {
                setOpenKeys(['1201'])
                history(`mac`)
                macSecurity(e.keyPath[0])
              } else {
                history(`mac/${e.keyPath[1]}/${e.keyPath[0]}`)
                macSecurity(e.keyPath[1], e.keyPath[0])
              }
            }}
          />
        </div>
        <div className="win_center">
          <div className="center_top">
            <span>全部WIN软件</span>
            <ul>
              <li
                className={classNames({ active: table === 1 })}
                onClick={() => {
                  setTable(1)
                  setCurrent(1)
                  const commendId = recommends.sort((a, b) => {
                    return a.id - b.id
                  })
                  setRecommends(commendId)
                }}>
                推荐
              </li>
              <li
                className={classNames({ active: table === 2 })}
                onClick={() => {
                  setTable(2)
                  setCurrent(1)
                  const sortNews = recommends.sort((a, b) => {
                    return (
                      Date.parse(b.publish_date) - Date.parse(a.publish_date)
                    )
                  })
                  setRecommend(sortNews)
                }}>
                最新
              </li>
              <li
                className={classNames({ active: table === 3 })}
                onClick={() => {
                  setTable(3)
                  setCurrent(1)
                  const sortDownload = recommends.sort((a, b) => {
                    return b.download_count - a.download_count
                  })
                  setRecommend(sortDownload)
                }}>
                下载
              </li>
              <li
                className={classNames({ active: table === 4 })}
                onClick={() => {
                  setTable(4)
                  setCurrent(1)
                  const sortComment = recommends.sort((a, b) => {
                    return b.remark_count - a.remark_count
                  })
                  setRecommend(sortComment)
                }}>
                评论
              </li>
            </ul>
          </div>
          <div className="center_bottom">
            {recommends.length ? (
              <ul>
                {table === 1 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:{Math.floor(item.download_count / 10000)}万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
                {table === 2 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:{Math.floor(item.download_count / 10000)}万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
                {table === 3 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:{Math.floor(item.download_count / 10000)}万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
                {table === 4 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:{Math.floor(item.download_count / 10000)}万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
              </ul>
            ) : (
              <Spin tip="Loading...">
                <Alert style={{ height: '50px' }} />
              </Spin>
            )}
          </div>
          <div className="fenye">
            <Pagination
              current={current}
              onChange={onChange}
              onShowSizeChange={(current, pageSize) => {
                setCurrent(current)
                setPageSize(pageSize)
              }}
              total={recommends.length}
              hideOnSinglePage={true}
              pageSize={pageSize}
            />
          </div>
        </div>
        <div className="win_right">
          <WeekHot hot={winWeek} />
          <AllRank hot={value.macHot} />
        </div>
      </div>
      <div
        className="retuntop"
        onClick={() => {
          window.scrollTo(0, 0)
        }}>
        <img src={returnTop} alt="" />
      </div>
    </>
  )
}
